import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEventTimes } from "../../../../store/reducers/reducerWeb";
import { useLiveEventCountdowns } from "../../../../utils/eventCountdown";
import { useLang } from "../../../../i18n/LangContext";
import "./events.scss";

const EventsTimes = () => {
  const dispatch = useDispatch();
  const { t } = useLang();
  const scrollTargetRef = useRef(null);
  const events = useSelector((s) => s.reducerWeb?.eventTimes?.data) || [];
  const liveEvents = useLiveEventCountdowns(events);

  useEffect(() => {
    dispatch(getEventTimes());
    const tick = setInterval(() => dispatch(getEventTimes()), 30000);
    return () => clearInterval(tick);
  }, [dispatch]);

  useEffect(() => {
    if (!scrollTargetRef.current) return;
    const yOffset = -80;
    const y =
      scrollTargetRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  return (
    <div ref={scrollTargetRef} className="events-container">
      <h2 className="events-title">{t("events_schedule")}</h2>
      <p className="events-subtitle">{t("events_subtitle")}</p>
      <table className="events-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{t("event_col_name")}</th>
            <th>{t("event_col_starts")}</th>
          </tr>
        </thead>
        <tbody>
          {liveEvents.length === 0 ? (
            <tr>
              <td colSpan={3}>{t("loading_events")}</td>
            </tr>
          ) : (
            liveEvents.map((event, index) => (
              <tr key={`${event.name}-${index}`}>
                <td>{index + 1}</td>
                <td>{event.name}</td>
                <td className="events-table__countdown">{event.time}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default EventsTimes;
